import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Award, Users, BookOpen, Star, MessageSquare, ChevronRight } from 'react-feather';
import "../../Component/home.css";
import Testimonials from "../Campus/Testimonials";
import Eventsdata from "../Eventdata/Eventsdata";
import HomeBlogs from "../Blogs/HomeBlogs";



const Home = () => {
  const items = [
    {
      icon: <Award size={28} />,
      title: "Proven Pedagogy",
      desc: "90% retention through peer-led teaching methods",
      gradient: "linear-gradient(135deg, #4f46e5, #6366f1)"
    },
    {
      icon: <Users size={28} />,
      title: "Holistic Development",
      desc: "Equal focus on academics and life skills",
      gradient: "linear-gradient(135deg, #14b8a6, #0f766e)"
    },
    {
      icon: <Star size={28} />,
      title: "Research-Backed",
      desc: "Curriculum designed by education experts",
      gradient: "linear-gradient(135deg, #a855f7, #7e22ce)"
    }
  ];


  const champions = [
    {
      id: 1,
      name: "Eleanor Fant",
      role: "Headmaster",
      image: "assets/images/Team/teacher_1.webp",
      social: [
        { icon: "facebook", link: "#" },
        { icon: "twitter", link: "#" },
        { icon: "linkedin", link: "#" }
      ]
    },
    {
      id: 2,
      name: "Fig Nelson",
      role: "Language Teacher",
      image: "assets/images/Team/teacher_2.webp",
      social: [
        { icon: "facebook", link: "#" },
        { icon: "twitter", link: "#" },
        { icon: "linkedin", link: "#" }
      ]
    },
    {
      id: 3,
      name: "Hanson Deck",
      role: "Special Education Teacher",
      image: "assets/images/Team/teacher_3.webp",
      social: [
        { icon: "facebook", link: "#" },
        { icon: "twitter", link: "#" },
        { icon: "linkedin", link: "#" }
      ]
    }

  ];

  const programs = [
    {
      title: "Parvam Program",
      description:
        "A structured 1-hour morning routine with meditation, affirmations, reading, and brain exercises.",
      image: "assets/images/programs/parvam_program.jpeg",
      aos: "fade-up",
    },
    {
      title: "Yummy Learning",
      description:
        "90-day English & Math booster with fun worksheets, hands-on tasks, and teacher-guided sessions.",
      image: "assets/images/programs/yummy_learning.jpg",
      aos: "fade-up",
    },
    {
      title: "Innoflip Classes",
      description:
        "Students master topics and teach peers, improving retention, confidence, and leadership skills.",
      image: "assets/images/programs/innoflip.jpg",
      aos: "fade-up",
    },
    {
      title: "Happy Beginning",
      description:
        "A 10-day revision program to refresh basics, routines, and ease kids into school with joy.",
      image: "assets/images/programs/happy_beginning.jpg",
      aos: "fade-up",
    },
    {
      title: "SCALE Life Skills",
      description:
        "Our program develops Social, Communication, Agility, Leadership, and Emotional skills.",
      image: "assets/images/programs/scale.jpg",
      aos: "fade-up",
    },
    {
      title: "Olympiad & Super 30",
      description:
        "Top students receive JEE & NEET coaching from experts. Many now study in top institutions.",
      image: "assets/images/programs/super30.jpg",
      aos: "fade-up",
    },
    {
      title: " (ESCP) Campus",
      description:
        "A language-rich environment with awards, help desks, mic corners, and learning tools.",
      image: "assets/images/programs/escp.jpg",
      aos: "fade-up",
    },
    {
      title: "R&D Team",
      description:
        "Our academic think tank handles curriculum strategy, mentoring, and board exam analysis.",
      image: "assets/images/programs/rd_team.jpg",
      aos: "fade-up",
    },
  ];

  const imageSources = [
    "/assets/images/banner1.jpg",
    "/assets/images/banner2.jpg",
    "/assets/images/banner3.jpg",
    "/assets/images/banner4.jpg",
    "/assets/images/banner5.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    AOS.init({ once: true, duration: 800 });
  }, []);

  // Auto image change every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imageSources.length);
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);



  return (
    <div>
      {/* <div className="site-wrapper"> */}
      {/* ======== 1.1. Header section ======== */}

      {/* ======== End of 1.1. Header section ========  */}
      {/* ======== 1.2. Hero section ========  */}
      <section
        className="position-relative"
        style={{
          backgroundImage: `url(${imageSources[currentIndex]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          transition: "background-image 1s ease-in-out",
        }}
      >
        {/* Optional dark overlay */}
        <div className="video-overlay" style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.5)",
          zIndex: 1
        }}></div>

        <div
          className="container text-white py-1  d-flex flex-column align-items-center justify-content-end text-center"
          style={{ minHeight: "90vh", zIndex: 2, position: "relative" }}
        >
          <h1 className="display-4 text-white fw-bold mb-1 mt-5 pt-5" data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="800" >
            Innovation Begins Here — <br />
            Shaping Future-Ready Learners at <span style={{ color: "#007BFF" }}>DNET Schools</span>
          </h1>
          <p className="text-white mb-4" data-aos="fade-up"
            data-aos-delay="400"
            data-aos-duration="800">
            Empowering students through 21st-century education, future skills, and values that last a lifetime.
          </p>
          <div className="d-flex flex-wrap gap-3 justify-content-center" data-aos="zoom-up"
            data-aos-delay="200"
            data-aos-duration="800">
            <a href="/programs" className="btn btn-primary  px-4 py-2 fw-bold rounded-pill shadow">
              Explore Our Programs
            </a>
            <a href="/visit-campus" className="btn btn-outline-light px-4 py-2 fw-bold rounded-pill shadow">
              Book a School Tour
            </a>
            <a href="/join-dnet" className="btn btn-light color px-4 py-2 fw-bold rounded-pill shadow">
              Join DNET Family
            </a>
          </div>
        </div>
      </section>

      <div className="pv-lms-area">
        <div className="container">
          <div className="lms-brand-wrap">
            {[
              { src: "assets/images/School/school1.jpg", name: "Captain's" },
              { src: "assets/images/School/school2.jpg", name: "St Joseph" },
              { src: "assets/images/School/school3.jpg", name: "St Paul's" },
              { src: "assets/images/School/school4.jpg", name: "Agaram" },
              { src: "assets/images/School/school5.jpg", name: "Jayag" },
              { src: "assets/images/School/school6.jpg", name: "Trinity" },
            ].map((item, index) => (
              <div className={`lms-brand lms-brand-${index + 1}`} key={index}>
                <div className="text-center border-dark">
                  <img
                    src={item.src}
                    alt={item.name}
                    style={{
                      maxWidth: "150px",
                      maxHeight: "180px",
                      borderRadius: "50%",
                    }}
                  />
                  {/* <div className="text-dark fw-semibold small mt-2">{item.name}</div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* core features */}
      <section>
        <div className="pv-feature-area d-none">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-6 col-md-12 sal-animate"
                data-sal-delay={100}
                data-sal="slide-up"
                data-sal-duration={1000}
              >
                <h2>
                  Core Features all Your <br /> Website Needs
                </h2>
              </div>
              <div
                className="col-lg-6 col-md-12 sal-animate"
                data-sal-delay={100}
                data-sal="slide-up"
                data-sal-duration={1000}
              >
                <p className="sub-title">
                  <span className="description">
                    EduBlink developed with the Elementor page builder plugin
                  </span>
                  . It has 70+ unique pages containing a full education management
                  system. The theme lets you build and manage an online enrollment
                  system effortlessly.
                </p>
              </div>
            </div>
            <div className="row g-5">
              <div
                className="col-xl-4 col-md-6 col-12 sal-animate"
                data-sal-delay={300}
                data-sal="slide-up"
                data-sal-duration={800}
              >
                <div className="feature-style-1">
                  <div className="inner">
                    <div className="thumbnail thumbnail-1 p-3">
                      <img
                        className="feature-img-1"
                        src="https://edublink.co/images/feature/feature-01.webp"
                        alt="Images"
                      />
                      <img
                        className="feature-img-2"
                        src="https://edublink.co/images/feature/feature-02.webp"
                        alt="Images"
                      />
                    </div>
                    <div className="content">
                      <h5 className="title">
                        Front-end Real-time <br /> Editing
                      </h5>
                      <p>
                        Build stunning pages just with these drag &amp; drop builders
                        and 50+ custom widgets exclusively
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-md-6 col-12 sal-animate"
                data-sal-delay={300}
                data-sal="slide-up"
                data-sal-duration={800}
              >
                <div className="feature-style-1">
                  <div className="inner">
                    <div className="thumbnail thumbnail-2 p-3">
                      <img
                        className="feature-img-1"
                        src="https://edublink.co/images/feature/feature-03.webp"
                        alt="Images"
                      />
                      <img
                        className="feature-img-2"
                        src="https://edublink.co/images/feature/feature-05.webp"
                        alt="Images"
                      />
                      <img
                        className="feature-img-3"
                        src="https://edublink.co/images/feature/feature-04.webp"
                        alt="Images"
                      />
                      <img
                        className="feature-img-4 round"
                        src="https://edublink.co/images/feature/feature-06.jpg"
                        alt="Images"
                      />
                    </div>
                    <div className="content">
                      <h5 className="title">
                        One Click Demo <br /> Import
                      </h5>
                      <p>
                        Make your website look exactly as our demo in a few clicks, no
                        extra setup is required.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-md-6 col-12 sal-animate"
                data-sal-delay={300}
                data-sal="slide-up"
                data-sal-duration={800}
              >
                <div className="feature-style-1 feature-padding">
                  <div className="inner">
                    <div className="thumbnail thumbnail-3">
                      <h5 className="title">Optimized loading.</h5>
                      <h2 className="counterup-item ">
                        <span className="counter">5</span>
                        <span className="percent">%</span>
                      </h2>
                      <div className="content-counter">
                        <div
                          className="expert-progressbar sal-animate"
                          data-sal-delay={150}
                          data-sal="slide-up"
                          data-sal-duration={800}
                        >
                          <div className="single-progressbar">
                            <p className="progress-title">EduBlink Theme</p>
                            <div className="progressbar-one">
                              <div
                                className="progressbar"
                                style={{ width: "75%", borderRadius: 4 }}
                              >
                                <div
                                  className="proggress"
                                  style={{ height: 7, borderRadius: 4, width: "98%" }}
                                >
                                  {" "}
                                  <div
                                    className="indicator"
                                    style={{ overflow: "visible" }}
                                  />
                                </div>
                              </div>
                              <div className="percentCount">98%</div>
                            </div>
                          </div>
                          <div className="single-progressbar">
                            <p className="progress-title">Other Themes</p>
                            <div className="progressbar-two">
                              <div
                                className="progressbar"
                                style={{ width: "75%", borderRadius: 4 }}
                              >
                                <div
                                  className="proggress"
                                  style={{ height: 7, borderRadius: 4, width: "70%" }}
                                >
                                  {" "}
                                  <div
                                    className="indicator"
                                    style={{ overflow: "visible" }}
                                  />
                                </div>
                              </div>
                              <div className="percentCount">70%</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="content">
                      <h5 className="title">
                        Top Notch <br /> Performance
                      </h5>
                      <p>
                        High performance, a good structure and well written source code.
                        All in one panel, No code required.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      {/* end core features */}

      {/* <section className="Hero position-relative overflow-hidden">
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          preload="auto"
          className="Hero-video"
        />

        <div className="video-overlay"></div>

        <div
          className="container text-white py-3 d-flex flex-column align-items-center justify-content-center text-center"
          style={{ minHeight: "80vh", zIndex: 2, position: "relative" }}
        >
          <h1 className="display-4 fw-bold text-white mb-3">
            Innovation Begins Here — <br />
            Shaping Future-Ready Learners at <span style={{ color: "#007BFF" }}>DNET Schools</span>
          </h1>
          <p className=" fw-bold  mb-4" style={{ color: "#007BFF" }}>
            Empowering students through 21st-century education, future skills, and values that last a lifetime.
          </p>
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            <a href="/programs" className="btn btn-primary px-4 py-2 rounded-pill shadow">Explore Our Programs</a>
            <a href="/visit-campus" className="btn btn-outline-light px-4 py-2 rounded-pill shadow">Book a School Tour</a>
            <a href="/join-dnet" className="btn btn-light text-primary px-4 py-2 rounded-pill shadow">Join DNET Family</a>
          </div>
        </div>
      </section> */}


      {/* ======== End of 1.2. Hero section ========  */}

      {/* ======== End of 1.3. About section ========  */}
      <section className="About d-none">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div
                className="d-flex flex-column justify-content-lg-center h-100 position-relative"
                data-aos="fade-up"
              >
                <h2>What<br />Makes Us Unique?</h2>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
                  sodales quis. Pulvinar consectetur amet cursus netus at.
                </p>
                <div>
                  <a href="About.html" className="hover1">
                    About More
                  </a>
                </div>
                <div>
                  <img
                    className="bounce-slow"
                    src="assets/images/icon/kite.svg"
                    alt="kite"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-8">
              <div className="d-flex position-relative" data-aos="fade-up">
                <figure className="w-100">
                  <img
                    className="w-100"
                    src="assets/images/index/About_img.webp"
                    alt="About_Img"
                  />
                </figure>
                <div className="d-flex flex-column ms-1 gap-lg-4 gap-3">
                  <div className="d-flex gap-lg-3 gap-2">
                    <figure className="rounded-circle">
                      <img src="assets/images/index/Learning.webp" alt="Learning" />
                    </figure>
                    <div>
                      <h6>Best Learning</h6>
                      <p>Lorem Ipsum is simply dummy text of the printing.</p>
                    </div>
                  </div>
                  <div className="d-flex gap-lg-3 gap-2">
                    <figure className="rounded-circle">
                      <img src="assets/images/index/Food.webp" alt="Food" />
                    </figure>
                    <div>
                      <h6>Nutritious Food</h6>
                      <p>Lorem Ipsum is simply dummy text of the printing.</p>
                    </div>
                  </div>
                </div>
                <div className="position-absolute">
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                    aliquet cursus mauris ut. Lorem ipsum dolor sit amet
                    consectetur.
                  </p>
                </div>
                <div>
                  <img
                    src="assets/images/icon/baloons.svg"
                    alt="baloon"
                    className="bounce-slow"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======== End of 1.3. About section ========  */}
      {/* ======== 1.4. Programs section ========  */}
      {/* DEMO */}
      <section className="py-5 px-3 container ">
        <div className="text-center mb-5 ">
          <h2 className="h2 display-5 fw-bold  " >What Makes Us Unique</h2>
          <div className="mx-auto my-2" style={{ width: "60px", height: "4px", backgroundColor: "#6610f2" }}></div>
          <p className="text-muted fs-5">
            Discover the innovative approaches that set our educational institution apart
          </p>
        </div>

        <div className="row g-4">
          {items.map((item, index) => (
            <div className="col-md-4" key={index} data-aos="zoom-in"
              data-aos-delay={`${index * 200}`}
              data-aos-duration="800">
              <div
                className="card border-0 shadow-sm h-100 text-center glass-card p-4 shadow-md"
                style={{
                  borderRadius: "1rem",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  background: "rgba(255,255,255,0.75)",
                  backdropFilter: "blur(10px)",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 1rem 2rem rgba(0,0,0,0.15)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 0.5rem 1rem rgba(0,0,0,0.1)";
                }}
              >
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: 64,
                      height: 64,
                      background: item.gradient,
                      color: "#fff",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
                    }}
                  >
                    {item.icon}
                  </div>
                </div>
                <div className="card-body">
                  <h5 className="fw-bold mb-2">{item.title}</h5>
                  <p className="text-muted">{item.desc}</p>
                </div>
                <div className="mt-auto pb-3 text-center">
                  <button
                    className="btn btn-sm d-inline-flex align-items-center gap-2 px-2 py-2 rounded-pill shadow-sm text-white border-0"
                    style={{
                      background: item.gradient,
                      transition: "all 0.3s ease-in-out"
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    Learn More <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* Section II: Meet Our Champions */}
      <section className="py-5 bg-white px-3 px-md-0 ">
        <div className="container">
          {/* Header */}
          <div className="text-center mb-5 ">
            <h2 className="h2 display-5 fw-bold  mb-3" >Meet Our Champions</h2>
            <div
              className="mx-auto"
              style={{
                width: '80px',
                height: '4px',
                backgroundColor: '#0d6efd',
                borderRadius: '2px',
              }}
            ></div>
          </div>

          {/* Card Grid */}
          <div className="row g-4">
            {champions.slice(0, 3).map((person, i) => (
              <div
                key={i}
                className="col-sm-6 col-md-6 col-lg-4"
                data-aos="zoom-in"
                data-aos-delay={`${i * 200}`}
                data-aos-duration="800"
              >
                <div className="champion-card position-relative overflow-hidden rounded-4 shadow-sm">
                  {/* Full Image */}
                  <img
                    src={person.image}
                    alt={person.name}
                    className="img-fluid w-100 h-100 object-fit-cover"
                    style={{ minHeight: "360px" }}
                  />

                  {/* Overlay: Name + Role */}
                  <div className="champion-info p-3 text-center">
                    <h5 className="mb-1 fw-bold">{person.name}</h5>
                    <p className="text-primary fw-semibold small mb-2">{person.role}</p>

                    {/* Social Icons */}
                    <div className="champion-icons d-flex justify-content-center gap-3">
                      <a href="#" className="text-dark">
                        <i className="bi bi-facebook"></i>
                      </a>
                      <a href="#" className="text-dark">
                        <i className="bi bi-instagram"></i>
                      </a>
                      <a href="#" className="text-dark">
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* END DEMO */}

      {/* ======== End of 1.4.Explore Our Flagship Programs ========  */}
      <div className="Courses_Choice_bg d-none">
        <section className="Courses">
          <div className="container">
            <div
              className="d-flex justify-content-center align-items-center text-center flex-column mx-auto"
              data-aos="fade-up"
            >
              <h2 className="h2 display-5 fw-bold">Explore Our Flagship Programs</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
                sodales quis.
              </p>
            </div>
            <div className="row Courses_Slider  g-2" data-aos="fade-up">
              {/* Card 1 */}
              <div className="col-lg-4 col-md-6 shadow-md">
                <div className="d-flex flex-column position-relative h-100"
                  style={{
                    borderRadius: '20px',
                    //  border: '1px solid #d4502a',
                    backgroundColor: '#fbf8f8',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden'
                  }}>
                  <figure className="m-0" style={{ height: '180px', overflow: 'hidden' }}>
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src="assets/images/slider/courses_1.webp"
                      alt="Drawing Class"
                      style={{ transition: 'transform 0.5s ease' }}
                    />
                  </figure>
                  <div className="d-flex flex-column text-center p-1 flex-grow-1">
                    <h4 className="fw-bold mt-1" style={{ color: '#1F0B45' }}>Drawing Class</h4>
                    <p className="mb-1" style={{ color: '#181818' }}>
                      Lorem ipsum dolor sit amet consectetur. Quis sed donec quis
                      nunc aliquet cursus mauris ut.
                    </p>
                    <div className="mt-auto mb-1">
                      <a href="Programs.html" className="hover3 fw-bold" style={{ color: '#d4502a' }}>
                        Join Now <i className="fas fa-arrow-right-long ms-2"></i>
                      </a>
                    </div>
                  </div>

                </div>
              </div>

              {/* Card 2 */}
              <div className="col-lg-4 col-md-6 shadow-md">
                <div className="d-flex flex-column position-relative h-100"
                  style={{
                    borderRadius: '20px',
                    //  border: '1px solid #d4502a',
                    backgroundColor: '#fbf8f8',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden'
                  }}>
                  <figure className="m-0" style={{ height: '180px', overflow: 'hidden' }}>
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src="assets/images/slider/courses_2.webp"
                      alt="Number Matching"
                      style={{ transition: 'transform 0.5s ease' }}
                    />
                  </figure>
                  <div className="d-flex flex-column text-center p-1 flex-grow-1">
                    <h4 className="fw-bold mt-1" style={{ color: '#1F0B45' }}>Number Matching</h4>
                    <p className="mb-1" style={{ color: '#181818' }}>
                      Lorem ipsum dolor sit amet consectetur. Quis sed donec quis
                      nunc aliquet cursus mauris ut.
                    </p>
                    <div className="mt-auto mb-1">
                      <a href="Programs.html" className="hover3 fw-bold" style={{ color: '#d4502a' }}>
                        Join Now <i className="fas fa-arrow-right-long ms-2"></i>
                      </a>
                    </div>
                  </div>

                </div>
              </div>

              {/* Card 3 */}
              <div className="col-lg-4 col-md-6 shadow-md">
                <div className="d-flex flex-column position-relative h-100"
                  style={{
                    borderRadius: '20px',
                    //  border: '1px solid #d4502a',
                    backgroundColor: '#fbf8f8',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden'
                  }}>
                  <figure className="m-0" style={{ height: '180px', overflow: 'hidden' }}>
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src="assets/images/slider/courses_3.webp"
                      alt="Paper Art"
                      style={{ transition: 'transform 0.5s ease' }}
                    />
                  </figure>
                  <div className="d-flex flex-column text-center p-1 flex-grow-1">
                    <h4 className="fw-bold mt-1" style={{ color: '#1F0B45' }}>Paper Art</h4>
                    <p className="mb-1" style={{ color: '#181818' }}>
                      Lorem ipsum dolor sit amet consectetur. Quis sed donec quis
                      nunc aliquet cursus mauris ut.
                    </p>
                    <div className="mt-auto mb-1">
                      <a href="Programs.html" className="hover3 fw-bold" style={{ color: '#d4502a' }}>
                        Join Now <i className="fas fa-arrow-right-long ms-2"></i>
                      </a>
                    </div>
                  </div>

                </div>
              </div>

              {/* Card 4 */}
              <div className="col-lg-4 col-md-6 shadow-md">
                <div className="d-flex flex-column position-relative h-100"
                  style={{
                    borderRadius: '20px',
                    //  border: '1px solid #d4502a',
                    backgroundColor: '#fbf8f8',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden'
                  }}>
                  <figure className="m-0" style={{ height: '180px', overflow: 'hidden' }}>
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src="assets/images/slider/courses_2.webp"
                      alt="Number Matching"
                      style={{ transition: 'transform 0.5s ease' }}
                    />
                  </figure>
                  <div className="d-flex flex-column text-center p-1 flex-grow-1">
                    <h4 className="fw-bold mt-1" style={{ color: '#1F0B45' }}>Shape Puzzle </h4>
                    <p className="mb-1" style={{ color: '#181818' }}>
                      Lorem ipsum dolor sit amet consectetur. Quis sed donec quis
                      nunc aliquet cursus mauris ut.
                    </p>
                    <div className="mt-auto mb-1">
                      <a href="Programs.html" className="hover3 fw-bold" style={{ color: '#d4502a' }}>
                        Join Now <i className="fas fa-arrow-right-long ms-2"></i>
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.5. Explore Our Flagship Programs ========  */}

        <Testimonials />
      </div>

      <section className="Courses">
        <div className="container">
          {/* Heading Section */}
          <div
            className="d-flex justify-content-center align-items-center text-center flex-column mx-auto mb-4"
            data-aos="fade-up"
          >
            <h2 className="h2 display-5 fw-bold">Explore Our Flagship Programs</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
              aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
              sodales quis.
            </p>
          </div>

          {/* Cards Slider */}
          <div className="row Courses_Slider g-3" data-aos="fade-up">
            {programs.map((program, index) => (
              <div
                className="col-lg-4 col-md-6 d-flex" // 👈 flex column wrapper
                key={index}
                data-aos={program.aos}
              >
                <div
                  className="d-flex flex-column position-relative w-100 h-100"
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "#fbf8f8",
                    transition: "all 0.3s ease",
                    overflow: "hidden",
                    border: "1px solid #e6e6e6",
                    padding: "15px",
                  }}
                >
                  <figure className="m-0" style={{ height: "190px", overflow: "hidden" }}>
                    <img
                      className="w-100 h-100"
                      src={program.image}
                      alt={program.title}
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                        transition: "transform 0.5s ease"
                      }}
                    />
                  </figure>

                  <div className="d-flex flex-column text-center p-2 flex-grow-1">
                    <h4 className="fw-bold mt-2" style={{ color: "#1F0B45" }}>
                      {program.title}
                    </h4>
                    <p className="mb-2 card-description" style={{ color: "#181818", fontSize: "0.95rem" }}>
                      {program.description}
                    </p>

                    {/* Sticky footer area */}
                    <div className="mt-auto mb-2">
                      <a
                        href="Programs.html"
                        className="hover3 fw-bold"
                        style={{ color: "#d4502a" }}
                      >
                        Join Now <i className="fas fa-arrow-right-long ms-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      <div className="Courses_Choice_bg">
        {/* Testimonials */}
        <Testimonials />
      </div>


      {/* ======== 1.8. Teachers section ========  */}
      <section className="Teachers d-none ">
        <div className="container">
          <hr />
          <div
            className="d-flex justify-content-center align-items-center text-center flex-column mx-auto"
            data-aos="fade-up"
          >
            <h2>Meet Our Champions</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
              aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
              sodales quis.
            </p>
          </div>
          <div className="row gy-sm-0 gy-4">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div
                className="position-relative overflow-hidden"
                data-aos="flip-left"
              >
                <figure>
                  <img
                    className="rounded-circle w-100"
                    src="assets/images/index/teacher_1.webp"
                    alt="teacher_1"
                  />
                </figure>
                <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                  <h3>Diyana</h3>
                  <p>CEO</p>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <a href="#">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fab fa-linkedin-in" />
                    </a>
                    <a href="#">
                      <i className="fab fa-pinterest-p" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div
                className="position-relative overflow-hidden"
                data-aos="flip-left"
              >
                <figure>
                  <img
                    className="rounded-circle w-100"
                    src="assets/images/index/teacher_2.webp"
                    alt="teacher_2"
                  />
                </figure>
                <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                  <h3>Jhon</h3>
                  <p>Teacher</p>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <a href="#">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fab fa-linkedin-in" />
                    </a>
                    <a href="#">
                      <i className="fab fa-pinterest-p" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <div
                className="position-relative overflow-hidden"
                data-aos="flip-left"
              >
                <figure>
                  <img
                    className="rounded-circle w-100"
                    src="assets/images/index/teacher_3.webp"
                    alt="teacher_3"
                  />
                </figure>
                <div className="position-absolute text-center h-100 w-100 flex-column align-items-center justify-content-center">
                  <h3>Watson</h3>
                  <p>Professor</p>
                  <div className="d-flex justify-content-center gap-2 align-items-center">
                    <a href="#">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href="#">
                      <i className="fab fa-linkedin-in" />
                    </a>
                    <a href="#">
                      <i className="fab fa-pinterest-p" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center" data-aos="fade-up">
            <a href="Team.html" className="hover1">
              View All Teachers
            </a>
          </div>
        </div>
      </section>

      {/* ======== 1.11. ChooseUs section ========  */}
      <section className="ChooseUs d-none">
        <div className="container">
          <div className="row flex-md-row flex-column-reverse gy-md-0 gy-4">
            <div className="col-lg-6 col-md-6">
              <figure data-aos="zoom-in-up">
                <img
                  className="w-100"
                  src="assets/images/index/chooseUs.webp"
                  alt="chooseUs"
                />
              </figure>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="d-flex flex-column ps-lg-4 mt-lg-4 mt-md-3">
                <div className="text-md-start text-center" data-aos="fade-up">
                  <h2>Practice Based Learning</h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                    aliquet cursus mauris ut. Enim fermentum maecenas rutrum dapibus
                    sodales quis.
                  </p>
                </div>
                <div className="d-flex flex-column gap-4" data-aos="fade-up">
                  <div className="d-flex gap-lg-3 align-items-center">
                    <figure className="rounded-circle d-flex justify-content-center align-items-center">
                      <img src="assets/images/icon/lab.svg" alt="lab" />
                    </figure>
                    <div>
                      <h6>Science Based Experiments</h6>
                      <p className="pt-1">
                        Lorem Ipsum is simply dummy text of the printing.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex gap-lg-3 align-items-center mt-lg-2">
                    <figure className="rounded-circle d-flex justify-content-center align-items-center">
                      <img src="assets/images/icon/Ruler.svg" alt="Ruler" />
                    </figure>
                    <div>
                      <h6>Mathematics and Experiments</h6>
                      <p className="pt-1">
                        Lorem Ipsum is simply dummy text of the printing.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-lg-5 mt-4" data-aos="fade-up">
                  <a href="Contact.html" className="hover1">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======== End of 1.11. ChooseUs section ========  */}
      {/* ======== 1.12. Enroll section ========  */}
      <section className="Enroll ">
        <div className="container">
          <div
            className="d-flex justify-content-end align-items-center text-center mt-5 flex-column"
            data-aos="fade-up"
          >
            <h1>Nurturing Young Hearts And Minds</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur. Venenatis pulvinar sapien urna
              blandit sit adipiscing. Quis parturient quisque malesuada pharetra
              scelerisque orci consectetur pulvinar. Consequat viverra morbi morbi
              vitae tincidunt tristique mi. Cursus sollicitudin augue imperdiet
              lectus gravida.
            </p>
            <div className="d-flex w-100 justify-content-center align-items-center">
              <a href="Programs.html" className="hover1">
                Enroll now
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* ======== End of 1.12. Enroll section ========  */}
      {/* ======== 1.13. FAQ section ========  */}
      <section className="FAQ d-none">
        <div className="container">
          <div className="row justify-content-md-between flex-md-row flex-column-reverse gy-md-0 gy-4">
            <div className="col-lg-5 col-md-5">
              <div className="position-relative">
                <figure className="m-0" data-aos="zoom-in-up">
                  <img
                    className="w-100"
                    src="assets/images/index/FAQ_Img.webp"
                    alt="FAQ_img"
                  />
                </figure>
                <div>
                  <img
                    className="position-absolute"
                    src="assets/images/index/OpenBook.webp"
                    alt="OpenBook"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-7">
              <div className="d-flex flex-column" data-aos="fade-up">
                <h1>FAQ</h1>
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h6 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Lorem ipsum dolor sit amet?
                      </button>
                    </h6>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore magna
                          aliqua. In vitae turpis massa sed elementum tempus egestas
                          sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                          nunc aliquet bibendum enim facilisis gravida
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h6 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Lorem ipsum dolor sit amet?
                      </button>
                    </h6>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore magna
                          aliqua. In vitae turpis massa sed elementum tempus egestas
                          sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                          nunc aliquet bibendum enim facilisis gravida
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h6 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Lorem ipsum dolor sit amet?
                      </button>
                    </h6>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore magna
                          aliqua. In vitae turpis massa sed elementum tempus egestas
                          sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                          nunc aliquet bibendum enim facilisis gravida
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h6 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Lorem ipsum dolor sit amet?
                      </button>
                    </h6>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                          sed do eiusmod tempor incididunt ut labore et dolore magna
                          aliqua. In vitae turpis massa sed elementum tempus egestas
                          sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                          nunc aliquet bibendum enim facilisis gravida
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======== End of 1.12. Enroll section ========  */}
      {/* ======== 1.13. News updates ========  */}
      <section className="blog-section Teachers d-none">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center text-center flex-column mx-auto " data-aos="fade-up">
            <h2 className="mb-3 mt-0">Latest News & Updates</h2>
          </div>
          {/*section-title end*/}
          <div className="blog-posts" data-aos="zoom-in" data-aos-delay="100" data-aos-duration="800">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="blog-post">
                  <div className="blog-thumbnail">
                    <img
                      src="/assets/images/Moments/moments_1.webp"
                      alt=""
                      className="w-100"
                    />{" "}
                    <span className="category">English</span>
                  </div>
                  <div className="blog-info">
                    <ul className="meta d-flex">
                      <li>
                        <a href="/" title="" className="me-1" >
                          17/09/2020
                        </a>
                      </li>
                      <li>
                        <a href="/" title="" className="me-1 ">
                          by Admin
                        </a>
                      </li>
                      <li>
                        <img src="assets/img/icon13.png" alt="" />
                        <a href="/" title="">
                          Teachers,
                        </a>
                        <a href="/" title="">
                          School
                        </a>
                      </li>
                    </ul>
                    <h3 className="text-warning">
                      <a href="/post" title="">
                        Campus clean workshop
                      </a>
                    </h3>
                    <p>
                      Nam mattis felis id sodales rutrum. Nulla ornare
                      tristique mauris, a laoreet erat ornare sit amet
                    </p>
                    <a href="/post" title="" className="read-more border-black mb-1">
                      Read <i className="fa fa-long-arrow-alt-right" />
                    </a>
                  </div>
                </div>
                {/*blog-post end*/}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="blog-post" data-aos="zoom-in-up" data-aos-delay="200" data-aos-duration="800">
                  <div className="blog-thumbnail">
                    <img
                      src="assets/images/Moments/moments_2.webp"
                      alt=""
                      className="w-100"
                    />{" "}
                    <span className="category">English</span>
                  </div>
                  <div className="blog-info">
                    <ul className="meta d-flex me-1 ">
                      <li>
                        <a href="/" title="" className="me-1 ">
                          17/09/2020
                        </a>
                      </li>
                      <li>
                        <a href="/" title="" className="me-1 " >
                          by Admin
                        </a>
                      </li>
                      <li>
                        <img src="assets/img/icon13.png" alt="" />
                        <a href="/" title="">
                          Teachers,
                        </a>
                        <a href="/" title="">
                          School
                        </a>
                      </li>
                    </ul>
                    <h3>
                      <a href="/post" title="">
                        Campus clean workshop
                      </a>
                    </h3>
                    <p>
                      Nam mattis felis id sodales rutrum. Nulla ornare
                      tristique mauris, a laoreet erat ornare sit amet
                    </p>
                    <a href="/post" title="" className="read-more mb-1">
                      Read <i className="fa fa-long-arrow-alt-right" />
                    </a>
                  </div>
                </div>
                {/*blog-post end*/}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="blog-post" data-aos="zoom-in-down" data-aos-delay="300" data-aos-duration="800">
                  <div className="blog-thumbnail">
                    <img
                      src="assets/images/Moments/moments_4.webp"
                      alt=""
                      className="w-100"
                    />{" "}
                    <span className="category">English</span>
                  </div>
                  <div className="blog-info">
                    <ul className="meta d-flex">
                      <li>
                        <a href="/" title="" className="me-1">
                          17/09/2020
                        </a>
                      </li>
                      <li>
                        <a href="/" title="" className="me-1 ">
                          by Admin
                        </a>
                      </li>
                      <li>
                        <img src="assets/img/icon13.png" alt="" />
                        <a href="/" title="">
                          Teachers,
                        </a>
                        <a href="/" title="">
                          School
                        </a>
                      </li>
                    </ul>
                    <h3>
                      <a href="/post" title="">
                        Campus clean workshop
                      </a>
                    </h3>
                    <p>
                      Nam mattis felis id sodales rutrum. Nulla ornare
                      tristique mauris, a laoreet erat ornare sit amet
                    </p>
                    <a href="/post" title="" className="read-more mb-1">
                      Read <i className="fa fa-long-arrow-alt-right" />
                    </a>
                  </div>
                </div>
                {/*blog-post end*/}
              </div>
            </div>
          </div>
          {/*blog-posts end*/}
        </div>
      </section>


      <Eventsdata />
      {/* ======== End of 1.13. News updates ========  */}
      {/* ======== 1.14. Newsletter section ========  */}
      <section className="Newsletter">
        <div className="container">
          <div className="row flex-md-row flex-column-reverse">
            <div className="col-lg-6 col-md-6">
              <figure
                className="d-flex justify-content-center align-items-center h-100"
                data-aos="zoom-in-up"
              >
                <img
                  className="w-100"
                  src="assets/images/index/train.webp"
                  alt="train"
                />
              </figure>
            </div>
            <div className="col-lg-6 col-md-6">
              <div
                className="d-flex flex-column text-md-start text-center"
                data-aos="fade-up"
              >
                <h2>Subscribe Our Newsletter</h2>
                <p>
                  Lorem ipsum dolor sit amet consectetur. Quis sed donec quis nunc
                  aliquet cursus mauris ut. Enim fermentum.
                </p>
                <form className="d-flex">
                  <input
                    type="email"
                    placeholder="Type Your Email"
                    required=""
                    name="Newsletter_Email"
                  />
                  <button className="hover1">Subscribe</button>
                </form>
                <div
                  className="modal fade"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex={-1}
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <img
                        src="assets/images/icon/Confirmation_1.gif"
                        alt="submitIcon"
                      />
                      <div>
                        <h4>Response Submitted</h4>
                        <h6>
                          Your details have been successfully submitted. Thanks
                        </h6>
                      </div>
                      <button
                        type="button"
                        className="hover2 m-auto"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ======== End of 1.14. Newsletter section ========  */}

      <HomeBlogs />

    </div>
  )
}

export default Home
